import React, { Component } from "react";
import { Icon, message, Button, Carousel } from 'antd';
import { Link } from 'react-router';
import style from './Main.css';
import { jsonToStr, sgiConfig } from 'rt-sd-common';

export default class MainBreadcrumb extends Component {
  constructor(props) {
    super(props);
    this.state = {
        msgList: []
    };
  }

  componentDidMount() {
    this.getMsg();
  }

  getMsg = () => {
    // console.log('nikNam', tool.getCookie("nikNam"))
    let req = {
        values: {
            receiverNam: tool.getCookie("nikNam") + ',' + tool.getCookie("userId")
        }
    };
    let success = (res) => {
        if (res && res.head.code === "0000") {
            console.log('list', res.body);
            this.state.msgList = res.body ? res.body : [];
        }else{
            message.warning(res.head.msg);
        }
    };
    commonClient.simplecall(sgiConfig.service_msg + "/inmail/my/noread/list", req, success);
  }

  
  goWarning = (info) => { 
    const { warnInfoCode } = JSON.parse(info.sendRcd.extendParam)
    console.log('warnInfoCode', warnInfoCode)
    let req = {
        warnInfoCode
    };
    let success = (res) => {
        if (res && res.head.code === "0000") {
            console.log('msgList', res.body);
            tool.popUIByUcv('scfp_UI_0102006',{'db_form_editdata': res.body}, "预警信息处理详情");
            this.senReaded(info);
        }else{
            message.warning(res.head.msg);
        }
    };
    commonClient.simplecall(sgiConfig.service_finc + "/risk/warn/info/detail", req, success);
  }

  senReaded = (info) => {
    const { pk, vsn } = info;
    let req = {
        pk, vsn
    };
    let success = (res) => {
        if (res && res.head.code === "0000") {
            console.log('res', res);
            this.getMsg();
        }else{
            message.warning(res.head.msg);
        }
    };
    commonClient.simplecall(sgiConfig.service_msg + "/inmail/read", req, success);
  }

  render() {
    const { msgList } = this.state;
    if(msgList.length > 0) {
        return <div className={style.breadTips}>
            <Carousel autoplay dots="false">
                {
                    msgList.map(x=> {
                        // return <Link to={'/scfp_UI_0102006?uuid=1E8D22AA-650A-462C-A151-CC5EFF1EFE21'}> { x.msgContent } </Link>;
                        // return <Button type="link" size="small" className={style.breadTipsWords} onClick={() => this.goWarning(x)}> { x.msgContent } </Button>
                        return <div>
                            <div className={style.breadTipsBox}>
                                {/* <p className={style.breadTipsAnimate}> */}
                                    <Icon type="sound" theme="filled" className={style.breadTipsIcon} />
                                    <Button type="link" size="small" className={`${style.breadTipsBtn} ${style.breadTipsWords}`} onClick={() => this.goWarning(x)}>
                                        <span className={style.breadTipsWords}> 
                                            { x.msgContent } 
                                        </span>
                                    </Button>
                                {/* </p> */}
                            </div>
                        </div>
                    })
                }
            </Carousel>
        </div>;
    } else {
        return null
    }
  }

}



// WEBPACK FOOTER //
// ./apps/pages/main/Tips.js